/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} True_Nice_Tern_TripInputs */

const en_true_nice_tern_trip = /** @type {(inputs: True_Nice_Tern_TripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bulk distributions`)
};

const de_true_nice_tern_trip = /** @type {(inputs: True_Nice_Tern_TripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massenverteilungen`)
};

/**
* | output |
* | --- |
* | "Bulk distributions" |
*
* @param {True_Nice_Tern_TripInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const true_nice_tern_trip = /** @type {((inputs?: True_Nice_Tern_TripInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<True_Nice_Tern_TripInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_true_nice_tern_trip(inputs)
	return de_true_nice_tern_trip(inputs)
});